import React from 'react';
import { Link } from 'react-router-dom';
import { UnstyledButton } from 'src/design/atoms/UnstyledButton';
import logo from 'src/assets/firetrol.png';
import config from 'src/config';

export interface ILogoProps {
  sx?: React.CSSProperties;
  to?: string;
}

/** @registry Firetrol logo image linking to the app's default path (or a custom `to`). */
export const Logo: React.FC<ILogoProps> = ({ sx, to }) => {
  return (
    <UnstyledButton component={Link} to={to ?? config.defaultPath} style={sx}>
      <img src={logo} height={30} />
    </UnstyledButton>
  );
};
